import styled from 'styled-components/macro';
import {colors, breakpoints, flex, textSizes, fonts} from '@styles/vars';

const navItem = `
    display: inline-flex;
    align-items: center;
    text-transform: capitalize;
    font-size: ${textSizes['16']};
    gap: 18px;
    font-family: ${fonts.body};
    transition: all 0.2s ease;
    .icon {
        color: ${colors.gray};
        transition: color 0.2s ease, transform 0.2s ease;
    }
    &:hover, &:focus,
    &.active {
        transform: translateX(4px);
        .icon {
            color: ${colors.blue};
            transform: scale(1.1);
        }
    }
`

export const Header = styled.div`
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${breakpoints.tablet} {
    button {
      display: none;
    }
  }
`

export const List = styled.ul`
  ${flex.col}
  gap: 24px;
  padding-left: 6px;

  ${breakpoints.tablet} {
    height: 100%;

    .pin-down {
      margin-top: auto;
    }
  }
`

export const MainItem = styled.div`
  ${navItem};
  font-size: large;
  white-space: nowrap;
  overflow: visible;
  padding-right: 8px;

  span {
    opacity: 1;
    transition: opacity 0.15s ease;
  }

  &.collapsed {
    justify-content: center;
    overflow: hidden;
    
    span {
      opacity: 0;
      width: 0;
    }

    .icon {
      margin: 0;
    }
  }

  button {
    ${navItem};
    font-size: large;
    transition: none;
    width: 100%;
  }

  ${breakpoints.tablet} {
    font-size: unset;

    button {
      font-size: unset;
    }
  }
`

export const LinksList = styled.ul`
  ${flex.col}
  gap: 16px;
  margin: 16px 0 0 36px;
  padding-right: 10px;
  font-size: ${textSizes['16']};

  a {
    transition: color 0.2s ease, transform 0.2s ease, padding-left 0.2s ease;
    display: block;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.3;

    &:hover, &:focus {
      color: ${colors.blue};
      transform: translateX(4px);
      padding-left: 4px;
    }
  }

  ${breakpoints.tablet} {
    font-size: ${textSizes['14']};
  }
`